const imsrAnnounce = {
  maintenanceDate: "2026/02/25"
};

export default imsrAnnounce;
